module.exports = __webpack_public_path__ + "img/fileIcon.78f93567.svg";